export function getHubspotCookie() {
  const cookie =
    document && document.cookie && document.cookie.match(/hubspotutk\=\w+/g);
  const hubspotCookie =
    cookie && cookie.length && cookie[0].split('=') && cookie[0].split('=')[1];
  return hubspotCookie;
}
